import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import KeywordCloud from '../components/KeywordCloud'; // KeywordCloud 컴포넌트 import

export const Home = () => {
    const [showIntro, setShowIntro] = useState(true);
    const [cloudRendered, setCloudRendered] = useState(false);
    const [transitioning, setTransitioning] = useState(false);

    // 워드 클라우드 렌더링 완료 콜백
    const handleRenderComplete = () => {
        setCloudRendered(true);
    };

    // 컴포넌트 전환 효과
    useEffect(() => {
        let currentTimer;
        const transitionDuration = 500; // 전환 효과 시간 (ms)

        // 화면 전환 함수
        const toggleView = () => {
            setTransitioning(true);

            setTimeout(() => {
                // 현재 상태 반전
                setShowIntro(prevState => {
                    const newState = !prevState;

                    // 다음 전환 타이머 설정 (현재 바뀐 후의 상태에 따라)
                    const nextDelay = newState ? 2000 : 12000; // true면 소개 화면(2초), false면 클라우드(12초)
                    currentTimer = setTimeout(toggleView, nextDelay);

                    return newState;
                });

                setTransitioning(false);
            }, transitionDuration);
        };

        // 초기 타이머 설정 (소개 화면 3초 후 전환)
        currentTimer = setTimeout(toggleView, 3000);

        // 컴포넌트 언마운트시 타이머 정리
        return () => {
            if (currentTimer) clearTimeout(currentTimer);
        };
    }, []); // 빈 의존성 배열로 마운트 시 한 번만 실행

    return (
        <div className="flex flex-col max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-auto">
            {/* 헤더 영역 */}
            <div className="h-[350px] relative mb-10">
                {/* 사이트 소개 영역 */}
                <div
                    className={`absolute inset-0 w-full text-center transition-all duration-500 ease-in-out 
                    ${transitioning || !showIntro ? 'opacity-0 pointer-events-none' : 'opacity-100'} py-24`}
                >
                    <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                        <span className="block">Paper Insight</span>
                        <span className="block text-primary-600 mt-2 text-3xl sm:text-4xl md:text-5xl">논문 연구를 쉽게</span>
                    </h1>

                    <div className="mt-3 mx-auto max-w-md">
                        <p className="text-gray-500 italic text-sm sm:text-base md:text-lg font-light tracking-wide">
                            Discover research papers that matter to you
                        </p>
                    </div>

                    <p className="mt-6 max-w-md mx-auto text-base text-gray-700 sm:text-lg md:mt-7 md:text-xl md:max-w-2xl leading-relaxed">
                        원하는 주제와 저자의 최신 논문을 자동으로 받아보세요.
                        <br className="hidden sm:block" />
                        중요한 연구를 놓치지 않고 쉽게 따라갈 수 있습니다.
                    </p>
                </div>

                {/* 워드 클라우드 영역 */}
                <div
                    className={`absolute inset-0 w-full transition-all duration-500 ease-in-out
                    ${transitioning || showIntro ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
                >
                    <h2 className="text-2xl font-bold text-center mb-4 text-gray-800">인기 키워드</h2>
                    <KeywordCloud
                        onRenderComplete={handleRenderComplete}
                        isVisible={!transitioning && !showIntro}
                    />
                </div>
            </div>

            {/* 버튼 영역 */}
            <div className="max-w-xl mx-auto grid grid-cols-1 gap-4 sm:grid-cols-2 min-w-48">
                <div className="transform transition-all hover:shadow-lg">
                    <Link
                        to="/subscription"
                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-primary-600 bg-white hover:bg-gray-50 border-primary-300 shadow-sm md:py-4 md:text-lg md:px-10"
                    >
                        내 구독설정
                    </Link>
                </div>
                <div className="transform transition-all hover:shadow-lg">
                    <Link
                        to="/my-reports"
                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-primary-600 bg-white hover:bg-gray-50 border-primary-300 shadow-sm md:py-4 md:text-lg md:px-10"
                    >
                        내 리포트
                    </Link>
                </div>
                <div className="rounded-md shadow transform transition-all hover:shadow-lg">
                    <Link
                        to="/papers"
                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 md:py-4 md:text-lg md:px-10"
                    >
                        논문 검색
                    </Link>
                </div>
                <div className="rounded-md shadow transform transition-all hover:shadow-lg">
                    <Link
                        to="/reports"
                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 md:py-4 md:text-lg md:px-10"
                    >
                        일일 리포트
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Home;